<template>
    <div class="md-layout">
        <div class="md-layout-item md-size-100">

            <md-card>
                <md-card-header class="md-card-header-icon md-card-header-green">
                    <div class="card-icon">
                        <md-icon>assignment</md-icon>
                    </div>
                    <h4 class="title">View Employee Details
                        <div class="text-right">
                            <md-button @click="goToEdit(employee.id)" class="md-primary md-dense">
                                <md-icon>edit</md-icon>
                                Edit Labour
                            </md-button>
                            <md-button @click="goBack" class="md-primary md-dense">Back to List</md-button>
                            <md-button class="md-primary classic-modal md-dense" @click="addToVendorModal = true" v-if="!employee.vendor_id">
                                Add to Vendor
                            </md-button>
                        </div>
                    </h4>
                </md-card-header>
                <md-card-content>
                    <div>
                        <div class="md-layout">
                            <div class="md-layout-item md-size-40 md-small-size-100">
                                <div class="picture-container">
                                    <div class="picture">
                                        PICTURE

                                    </div>
                                    <h6 class="description">Choose Picture</h6>
                                </div>
                            </div>
                            <div class="md-layout-item md-size-60 mt-4 md-small-size-100">
                                <md-card-content>
                                    <md-table>
                                        <row-item-view :value="employee.check_no"
                                                       label="Employee Number"></row-item-view>
                                        <row-item-view :value="employee.name" label="Full Name"></row-item-view>
                                        <row-item-view :value="employee.skilled ? 'Yes' : 'No'"
                                                       label="Skilled"></row-item-view>
                                        <row-item-view :value="employee.nida_number" label="Nida"></row-item-view>
                                        <row-item-view :value="employee.email" label="Email"></row-item-view>
                                        <row-item-view :value="employee.vendor_name" label="Vendor"></row-item-view>
                                        <row-item-view :value="employee.check_no" label="Employee"></row-item-view>
                                    </md-table>
                                </md-card-content>
                            </div>
                        </div>
                    </div>
                    <template>
                        <modal v-if="addToVendorModal" @close="addToVendorModalHide">
                            <template slot="header">
                                <h4 class="modal-title">Add <b>{{employee.name}}</b> to Vendor</h4>
                                <md-button class="md-simple md-just-icon md-round modal-default-button"
                                           @click="addToVendorModalHide">
                                    <md-icon>clear</md-icon>
                                </md-button>
                            </template>

                            <template slot="body">
                                <div class="md-layout">
                                    <label class="md-layout-item md-size-25 md-form-label">Vendor</label>
                                    <div class="md-layout-item">
                                        <md-field class="md-invalid">
                                            <multiselect v-model="employee.vendor" id="index" label="name"
                                                         track-by="id"
                                                         placeholder="select vendor"
                                                         open-direction="bottom"
                                                         :options="vendors" :searchable="true"
                                                         :close-on-select="true"
                                                         :hide-selected="false">
                                                <span slot="noResult">Oops! No vendor found.</span>
                                            </multiselect>
                                            <validation-error :errors="apiValidationErrors.vendor"/>
                                        </md-field>
                                    </div>
                                </div>
                            </template>

                            <template slot="footer">
                                <md-button class="md-simple" @click="update">Submit</md-button>
                                <md-button class="md-danger md-simple" @click="addToVendorModalHide">Close</md-button>
                            </template>
                        </modal>
                    </template>

                </md-card-content>
            </md-card>
        </div>
    </div>
</template>
<script>
import { Modal, ValidationError } from '@/components';
import RowItemView from '../../../components/Inputs/RowItemView';
import formMixin from '@/mixins/form-mixin';
import Multiselect from 'vue-multiselect';


export default {
    components: {
        RowItemView,
        Modal,
        Multiselect, ValidationError
    },
    mixins: [formMixin],
    data () {
        return {
            addToVendorModal: false,
            vendors: [],
            employee: {
                type: 'employees',
                check_no: null,
                first_name: null,
                middle_name: null,
                last_name: null,
                nida_number: null,
                phone_number: null,
                vendor_id: null,
                vendor_name: null,
                email: null,
                uuid: null,
                vendor: {}
            },
        };
    },
    created () {
        this.get();
    },
    computed: {
        shoppingTotal () {
            return this.shoppingCartTable.reduce((accumulator, current) => {
                return accumulator + current.amount;
            }, 0);
        }
    },
    methods: {
        async get () {
            try {
                const id = this.$route.params.id;
                await this.$store.dispatch('employees/get', id);
                this.employee = this.$store.getters['employees/employee'];
                await this.getVendors();
            } catch (e) {
                await this.$store.dispatch(
                    'alerts/alert',
                    e.response
                );
            }
        },
        async getVendors () {
            await this.$store.dispatch('vendors/list');
            this.vendors = this.$store.getters['vendors/list'];
        },
        async update () {
            if (typeof this.employee.vendor !== 'undefined') {
                this.employee.vendor_id = this.employee.vendor.id;
            }
            try {
                await this.$store.dispatch('employees/update', this.employee);
                await this.$store.dispatch(
                    'alerts/success',
                    'Employee updated successfully.'
                );
                await this.$store.dispatch('employees/get', this.employee.id);
                this.employee  = this.$store.getters['employees/employee'];
                this.addToVendorModalHide();
            } catch (e) {
                await this.$store.dispatch('alerts/alert', e.response ? e.response : e.message);
                this.setApiValidation(e.response.data.errors);
            }
        },
        goToEdit (id) {
            this.$router.push({ name: 'Edit Employee', params: { id } });
        },
        goBack () {
            this.$router.push({ name: 'Employees List' });
        },
        addToVendorModalHide: function () {
            this.addToVendorModal = false;
        },

    }
};
</script>
<style lang="scss" scoped>
    .text-right .md-table-cell-container {
        display: flex;
        justify-content: flex-end;
    }

    .md-table .md-table-head:last-child {
        text-align: right;
    }

    .table-stats {
        display: flex;
        align-items: center;
        text-align: right;
        flex-flow: row wrap;

        .td-price .td-total {
            display: inline-flex;
            font-weight: 500;
            font-size: 1.0625rem;
            margin-right: 50px;
        }

        &.table-striped .td-price {
            border-bottom: 0;
        }

        .td-price {
            font-size: 26px;
            border-top: 1px solid #ddd;
            border-bottom: 1px solid #ddd;
        }

        .td-price,
        > div {
            flex: 0 0 100%;
            padding: 12px 8px;
        }
    }

    .table-shopping .md-table-head:nth-child(5),
    .table-shopping .md-table-head:nth-child(7),
    .table-shopping .md-table-head:nth-child(6) {
        text-align: right;
    }
</style>
